import React from 'react';
export function WebhookIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("g", {
    clipPath: "url(#svg__070f9__clip0_5779_58002)"
  }, React.createElement("path", {
    d: "M21 16.216a3.988 3.988 0 00-1.172-2.828l1.415-1.415a6 6 0 11-10.16 5.243h-2.35a2 2 0 110-2H13v1a4 4 0 008 0z"
  }), React.createElement("path", {
    d: "M5.026 19.651a3.988 3.988 0 003.035.4l.518 1.932a6 6 0 11.54-11.42l1.174-2.036a2 2 0 012.733-2.732 2 2 0 01-1 3.732l-1.176 2.036-.958 1.66-.866-.5a4 4 0 10-4 6.928z"
  }), React.createElement("path", {
    d: "M9.974 4.138a3.987 3.987 0 00-1.863 2.43L6.179 6.05a6 6 0 119.62 6.177l1.175 2.035a1.999 1.999 0 011 3.733 2 2 0 01-2.732-2.733l-1.175-2.035-.959-1.66.866-.5a4 4 0 00-4-6.929z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "svg__070f9__clip0_5779_58002"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}